import React from "react";
import { useState } from "react";
import { FaEdit, FaUser } from "react-icons/fa";
import {
  MdOutlineContentCopy,
  MdCheck,
  MdOutlinePendingActions,
  MdRemoveRedEye,
  MdOutlineSearchOff,
} from "react-icons/md";
import { TbArrowBackUp, TbArrowForwardUp } from "react-icons/tb";
import { LOANEE_DEATH_CASE } from "../../../../api/api_routing_urls";
import useAuth from "../../../../authentication/hooks/useAuth";
import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import Button from "../../../../reusable-components/buttons/Button";
import ConfirmationModal from "../../../../reusable-components/modals/ConfirmationModal";
import TableWrapper from "../../../../reusable-components/table/TableWrapper";
import {
  linkTextPrimary,
  linkTextSecondary,
} from "../../../../theme/lightTheme";

export default function NocApplicationList({
  loaneeNocApplicationList,
  setViewNocApplicationDetail,
  setNocApplicationDetail,
}) {
  return (
    <>
      <TableWrapper>
        {/* <thead className="bg-white text-xs  md:text-sm z-60">
          <tr className="bg-slate-200 sticky top-0">
            <th scope="col" className="px-3 py-2 text-left font-medium">
              SI No
            </th>
            <th scope="col" className="px-3 py-2 text-left font-medium">
              NOC Serial No
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left font-medium flex flex-col min-w-44"
            >
              <span>Applicant Name</span>{" "}
            </th>
            <th scope="col" className="px-3 py-2 text-left font-medium">
              Relative Name
            </th>

            <th scope="col" className="px-3 py-2 text-left font-medium">
              Department Name
            </th>

            <th scope="col" className="px-3 py-2 text-left font-medium">
              Status
            </th>
            <th scope="col" className="px-3 py-2 text-left font-medium">
              Is Loanee
            </th>

            <th scope="col" className="px-3 py-2 text-center font-medium">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-slate-100 text-slate-600">
          {loaneeNocApplicationList?.length > 0 ? (
            loaneeNocApplicationList?.map(
              (loaneeNocApplicationDetail, index) => (
                <tr
                  key={index}
                  className={index % 2 === 1 ? "bg-slate-100" : null}
                >
                  <td className="px-3 py-1.5 whitespace-nowrap text-xs 2xl:text-sm font-semibold">
                    <p>{loaneeNocApplicationDetail?.serial_no}</p>
                  </td>
                  <td className="px-3 py-1.5 whitespace-nowrap text-xs 2xl:text-sm font-semibold">
                    <p>{loaneeNocApplicationDetail?.noc_serial_no}</p>
                  </td>
                  <td className="px-3 py-1.5 whitespace-nowrap text-xs 2xl:text-sm font-semibold">
                    <p>{loaneeNocApplicationDetail?.noc_name}</p>
                  </td>
                  <td className="px-3 py-1.5 whitespace-nowrap text-xs 2xl:text-sm font-semibold">
                    <p>{loaneeNocApplicationDetail?.noc_relative_name}</p>
                  </td>

                  <td className="px-3 py-1.5 whitespace-nowrap text-xs 2xl:text-sm font-semibold">
                    <p>{loaneeNocApplicationDetail?.noc_department_name}</p>
                  </td>
                  <td className="px-3 py-1.5 whitespace-nowrap text-xs 2xl:text-sm font-semibold">
                    <p>
                      <>
                        {loaneeNocApplicationDetail?.isverified &&
                        loaneeNocApplicationDetail?.isverified !== null ? (
                          <span className="text-green-600 flex gap-1 items-center">
                            <span>Verified</span>
                            <MdCheck size={18} />
                          </span>
                        ) : (
                          <span className="text-yellow-600 flex gap-1 items-center">
                            <span>Pending</span>
                            <MdOutlinePendingActions size={18} />
                          </span>
                        )}
                      </>
                    </p>
                  </td>
                  <td className="px-3 py-1.5 whitespace-nowrap text-xs 2xl:text-sm font-semibold">
                    <p>
                      {loaneeNocApplicationDetail?.isverified &&
                      loaneeNocApplicationDetail?.isverified !== null ? (
                        <>
                          {loaneeNocApplicationDetail?.isloanee &&
                          loaneeNocApplicationDetail?.isloanee !== null ? (
                            <span className="text-yellow-600 flex gap-1 items-center">
                              <span>Loanee</span>
                            </span>
                          ) : (
                            <span className="text-green-600 flex gap-1 items-center">
                              <span>Not Loanee</span>
                              <MdCheck size={18} />
                            </span>
                          )}
                        </>
                      ) : (
                        <span className="text-yellow-600 flex gap-1 items-center">
                          <span>Pending</span>
                          <MdOutlinePendingActions size={18} />
                        </span>
                      )}
                    </p>
                  </td>

                  <td className="px-3 py-1.5 whitespace-nowrap text-sm">
                    <div className="flex justify-center ">
                      <Button
                        onClick={() => {
                          setNocApplicationDetail(loaneeNocApplicationDetail);
                          setViewNocApplicationDetail(true);
                        }}
                        aria-label="View Sub menu"
                        className={linkTextPrimary}
                      >
                        <span className="text-primary">
                          <MdRemoveRedEye size={18} />
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ),
            )
          ) : (
            <>
              <tr className="m-auto text-center">
                <td colSpan={9} className="py-1">
                  No List Found
                </td>
              </tr>
            </>
          )}
        </tbody> */}

        <thead className="sticky top-0 z-0 border-b border-slate-200 bg-white shadow-sm">
          <tr>
            {[
              "#",
              "Reference",
              "Applicant",
              "Application Details",
              "Verification",
              "Payment",
              "Actions",
            ].map((head) => (
              <th
                key={head}
                className="px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500"
              >
                {head}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="divide-y divide-slate-100 bg-white">
          {loaneeNocApplicationList?.length > 0 ? (
            loaneeNocApplicationList.map((item, index) => (
              <tr
                key={item.noc_id}
                className={`transition-all duration-200 hover:bg-primary/5

        ${
          !item.is_convenience_fee_paid
            ? "border-l-4 border-amber-400 bg-amber-50/40"
            : !item.isverified
              ? "border-l-4 border-blue-400 bg-blue-50/30"
              : ""
        }`}
              >
                {/* SERIAL */}
                <td className="px-5 py-2 text-sm font-medium text-slate-500">
                  {index + 1}
                </td>

                {/* REFERENCE */}
                <td className="px-5 py-2">
                  <div className="flex items-center gap-3">
                    <div>
                      <p className="font-mono text-sm font-bold tracking-wide text-primary">
                        {item.noc_serial_no}
                      </p>

                      <p className="text-xs text-slate-400">NOC Serial No.</p>
                    </div>

                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(item.noc_serial_no);
                      }}
                      className="rounded-md p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-primary"
                      title="Copy Reference"
                    >
                      <MdOutlineContentCopy size={15} />
                    </button>
                  </div>
                </td>

                {/* APPLICANT */}
                <td className="px-5 py-2">
                  <div className="flex items-start gap-3">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 font-semibold uppercase text-primary">
                      {item.noc_name?.charAt(0)}
                    </div>

                    <div>
                      <p className="font-semibold text-slate-900">
                        {item.noc_name}
                      </p>

                      <p className="text-sm text-slate-500">
                        {item.noc_relative_name}
                      </p>

                      <span
                        className={`mt-2 inline-flex rounded-full border px-2.5 py-1 text-xs font-medium

                ${
                  !item?.isverified
                    ? "border-yellow-200 bg-yellow-50 text-yellow-700"
                    : item.isloanee
                      ? "border-red-200 bg-red-50 text-red-700"
                      : "border-emerald-200 bg-emerald-50 text-emerald-700"
                }`}
                      >
                        {item?.isverified ? (
                          <>
                            <MdCheck size={15} />
                            {item.isloanee ? "Loanee" : "Non-Loanee"}
                          </>
                        ) : (
                          <>
                            <MdOutlinePendingActions size={15} />
                            Pending Verification
                          </>
                        )}
                      </span>
                    </div>
                  </div>
                </td>

                {/* APPLICATION DETAILS */}
                <td className="px-5 py-2">
                  <div className="space-y-3">
                    <div>
                      <p className="mb-1 text-[11px] font-medium uppercase tracking-wide text-slate-400">
                        Purpose
                      </p>

                      {item.noc_purpose ? (
                        <span className="inline-flex rounded-full border border-indigo-200 bg-indigo-50 px-3 py-1 text-xs font-medium text-indigo-700">
                          {item.noc_purpose}
                        </span>
                      ) : (
                        <span className="italic text-slate-400">
                          Not Specified
                        </span>
                      )}
                    </div>

                    <div>
                      <p className="mb-1 text-[11px] font-medium uppercase tracking-wide text-slate-400">
                        Department
                      </p>

                      {item.noc_department_name ? (
                        <span className="text-sm font-medium text-slate-700">
                          {item.noc_department_name}
                        </span>
                      ) : (
                        <span className="italic text-slate-400">
                          Not Assigned
                        </span>
                      )}
                    </div>
                  </div>
                </td>

                {/* VERIFICATION */}
                <td className="px-5 py-2 align-top">
                  <div className="space-y-2">
                    <span
                      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold
              ${
                item.isverified
                  ? "border-green-200 bg-green-50 text-green-700"
                  : "border-amber-200 bg-amber-50 text-amber-700"
              }`}
                    >
                      {item.isverified ? (
                        <>
                          <MdCheck size={15} />
                          Verified
                        </>
                      ) : (
                        <>
                          <MdOutlinePendingActions size={15} />
                          Pending Verification
                        </>
                      )}
                    </span>

                    {item.updatedat && (
                      <p className="text-sm text-slate-600">
                        Updated{" "}
                        {new Date(item.updatedat).toLocaleDateString("en-IN")}
                      </p>
                    )}
                  </div>
                </td>

                {/* PAYMENT */}
                <td className="px-5 py-2 align-top">
                  <div className="space-y-2">
                    <span
                      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold
              ${
                item.is_convenience_fee_paid
                  ? "border-green-200 bg-green-50 text-green-700"
                  : "border-amber-200 bg-amber-50 text-amber-700"
              }`}
                    >
                      {item.is_convenience_fee_paid ? (
                        <>
                          <MdCheck size={15} />
                          Paid
                        </>
                      ) : (
                        <>
                          <MdOutlinePendingActions size={15} />
                          Payment Pending
                        </>
                      )}
                    </span>

                    {item?.is_convenience_fee_paid &&
                      item?.convenience_fee_payment_mode && (
                        <div>
                          <p className="text-sm text-slate-600">
                            Mode: {item.convenience_fee_payment_mode}
                          </p>
                        </div>
                      )}
                  </div>
                </td>

                {/* ACTION */}
                <td className="px-5 py-2 text-center align-top">
                  <button
                    onClick={() => {
                      setNocApplicationDetail(item);
                      setViewNocApplicationDetail(true);
                    }}
                    className="group inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm transition-all duration-200 hover:border-primary hover:bg-primary hover:text-white hover:shadow-md"
                  >
                    <MdRemoveRedEye
                      size={18}
                      className="transition-colors group-hover:text-white"
                    />
                    View
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={7} className="px-6 py-20">
                <div className="flex flex-col items-center justify-center">
                  <div className="mb-5 flex h-20 w-20 items-center justify-center rounded-full bg-slate-100">
                    <MdOutlineSearchOff className="text-slate-400" size={42} />
                  </div>

                  <h3 className="text-lg font-semibold text-slate-700">
                    No Applications Found
                  </h3>

                  <p className="mt-2 max-w-md text-center text-sm text-slate-500">
                    We couldn't find any NOC applications matching your search.
                    Try changing the search keyword or clearing the applied
                    filters.
                  </p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </TableWrapper>
    </>
  );
}
